
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.328 21.313l.328-.329a.54.54 0 000-.797l-8.344-8.39h17.625a.57.57 0 00.563-.563v-.468c0-.282-.281-.563-.563-.563H3.313l8.344-8.344a.54.54 0 000-.796l-.328-.329a.54.54 0 00-.797 0l-9.89 9.891a.54.54 0 000 .797l9.89 9.89a.54.54 0 00.797 0z","fill":"currentColor"}})])
          )
        }
      }
    